import { MyHRUserNotFoundPage } from "my-hr/pages/user-not-found-page";

export const ocRoutes = [
  {
    id: "404",
    path: "/404",
    exact: true,
    private: true,
    component: MyHRUserNotFoundPage,
    roles: ["MyHR.user"],
  },
];
